module.exports = __webpack_public_path__ + "images/bf-background-mobile.jpg";